export default "__VITE_ASSET__Dcw0ETlq__"